import { Typography } from "@material-ui/core";
import { get } from "lodash";
import { useRecordContext } from "react-admin";

interface IPricingPolicyField {
  source: string;
  label?: string;
  emptyText?: string;
}

const PricingPolicyField = ({ source }: IPricingPolicyField) => {
  const record = useRecordContext();
  const data = get(record, source);

  console.log(data);

  return (
    <Typography variant="body2">
      {data === undefined || data === null
        ? `-`
        : data
        ? "Full Calendar Days"
        : "Contact Days"}
    </Typography>
  );
};

export default PricingPolicyField;
